import { Button, CircularProgress, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { Edit, Info, Image, List, Trash2 } from "react-feather";

export const MenuOptions = ({ params, Actions, formOpeningMode }) => {
    const { idcollateral } = params.data;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const {
        handleClickFetchInfoCollateral,
        handleClickDeleteCollateral,
        handleClickShowCollateralImages,
        pending
    } = Actions;

    const isReadOnly = formOpeningMode === "READONLY";

    return (
        <>
            <Button
                startIcon={<List />}
                variant="contained"
                size="small"
                color={isReadOnly ? "info" : "success"}
                sx={{ marginRight: "8px" }}
                onClick={handleMenuOpen}
                style={{ width: 150 }}
            >
                {isReadOnly ? "Ver Detalles" : "Opciones"}
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                {/* IMÁGENES -> Detalle Imágenes en READONLY */}
                <MenuItem
                    onClick={() => {
                        handleClickShowCollateralImages(idcollateral);
                        handleMenuClose();
                    }}
                >
                    <ListItemIcon>
                        <Image color="black" />
                    </ListItemIcon>
                    <ListItemText primary={isReadOnly ? "Detalle Imágenes" : "Imágenes"} />
                </MenuItem>

                {/* EDITAR -> Detalle Datos en READONLY */}
                <MenuItem
                    onClick={() => {
                        handleClickFetchInfoCollateral(idcollateral, isReadOnly ? "READONLY" : "EDITABLE");
                        handleMenuClose();
                    }}
                >
                    <ListItemIcon>
                        {isReadOnly ? <Info color="black" /> : <Edit color="black"/>}
                    </ListItemIcon>
                    <ListItemText primary={isReadOnly ? "Detalle Datos" : "Editar"} />
                </MenuItem>

                {/* ELIMINAR SOLO EN EDITABLE */}
                {!isReadOnly && (
                    <MenuItem
                        onClick={() => {
                            handleClickDeleteCollateral(idcollateral);
                            handleMenuClose();
                        }}
                        disabled={pending.deleteCollateral}
                    >
                        <ListItemIcon>
                            {pending.deleteCollateral
                                ? <CircularProgress size={16} color="inherit" />
                                : <Trash2 color="black" />
                            }
                        </ListItemIcon>
                        <ListItemText primary="Eliminar" />
                    </MenuItem>
                )}
            </Menu>
        </>
    );
};